var map = {
	"./Medical-and-Psychological-Assesment-Camp-1-300x225.jpg": 2851,
	"./Medical-and-Psychological-Assesment-Camp-10-300x213.jpeg": 1159,
	"./Medical-and-Psychological-Assesment-Camp-11-300x291.jpeg": 5154,
	"./Medical-and-Psychological-Assesment-Camp-12-300x284.jpeg": 2381,
	"./Medical-and-Psychological-Assesment-Camp-2-300x225.jpg": 1928,
	"./Medical-and-Psychological-Assesment-Camp-3-300x225.jpg": 941,
	"./Medical-and-Psychological-Assesment-Camp-4-300x200.jpg": 8581,
	"./Medical-and-Psychological-Assesment-Camp-5-300x225.jpg": 7111,
	"./Medical-and-Psychological-Assesment-Camp-6-300x225.jpg": 3436,
	"./Medical-and-Psychological-Assesment-Camp-7-300x136.jpeg": 5479,
	"./Medical-and-Psychological-Assesment-Camp-8-300x296.jpeg": 2909,
	"./Medical-and-Psychological-Assesment-Camp-9-300x137.jpeg": 4806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2904;